import { usePage } from "PFApp/use_page";
// import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";

export const useCustomizationPage = (initPage, accountId) => {
  const { page, setPage, mergePage, resetPage } = usePage(`features`, initPage);

  const fetch = () =>
    $.ajax({
      url: ApiRoute(`/api/saas_admin/accounts/${accountId}/customization/`)
    })
      .then((response) =>
        mergePage({
          loaded: true,
          customization: formatResponse(response)
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );

  const fetchAccount = () =>
    $.ajax({
      url: ApiRoute(`/api/saas_admin/accounts/${accountId}`)
    })
      .then(({ name }) =>
        mergePage({
          accountName: name
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );

  const putCustomization = (data) => {
    mergePage({ saving: true });

    return $.ajax({
      url: ApiRoute(`/api/saas_admin/accounts/${accountId}/customization`),
      method: "PUT",
      contentType: false,
      processData: false,
      data: data
    })
      .then((response) => {
        mergePage({
          loaded: true,
          saving: false,
          customization: response
        });
        return true;
      })
      .catch(() => {
        mergePage({
          loaded: true,
          saving: false,
          errors: ["there was an error"]
        });
        return false;
      });
  };

  // Each custom link needs a unique id to prevent react rendering them incorrectly on remove
  const formatResponse = (response) => {
    const startId = Date.now();
    response.custom_links = response.custom_links.map((customLink, index) => {
      customLink.id = startId + index;
      return customLink;
    });
    return response;
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetchAccount();
    fetch();
  }, []);

  return { ...page, putCustomization };
};
